export default "__VITE_ASSET__ByAy1Bjf__"